module.exports = __webpack_public_path__ + "img/img-5.7320a1ee.png";